/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum WalletClientStatusEnum {
  "ENABLED" = "ENABLED",

  "DISABLED" = "DISABLED"
}

/**
 * Enumeration of wallet client statuses
 */

export type WalletClientStatus = t.TypeOf<typeof WalletClientStatus>;
export const WalletClientStatus = enumType<WalletClientStatusEnum>(
  WalletClientStatusEnum,
  "WalletClientStatus"
);
